export enum EventsTypesMinor {
    ScheduledCall = "scheduledCall",
    ConciergeRequest = "conciergeRequest",
    Social = "social",
    Visit = "Visit",
    Notice = "Notice",
    RealtimeCall = "realtimeCall"
}
